import { createStyles, makeStyles } from '@material-ui/core/styles';
import { drawerWidth } from './Layout';

const useStyles = makeStyles((theme) =>
  createStyles({
    content: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '100%',
      height: '100vh',
      // necessary for content to be below app bar
      '&::before': {
        content: `''`,
        ...theme.mixins.toolbar,
      },
    },
    contentUnshift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerWidth,
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
      maxWidth: `calc(100% - ${drawerWidth}px)`,
    },
  }),
);
export default useStyles;
